<div class="content">

  <div class="row">
    <div class="col-12">
      <div class="header-wrapper">
        <div class="user">
          <ngx-avatar name="{{data.USER?.getName()}}" size="48"></ngx-avatar>
          <div class="user-name" *ngIf="data.USER.FIRST_NAME && data.USER.LAST_NAME">{{data.USER?.FIRST_NAME+' '+data.USER?.LAST_NAME}}</div>
          <div class="user-email" *ngIf="data.USER.EMAIL">
            <a href="mailto:{{data.USER.EMAIL}}">{{data.USER.EMAIL}}</a>
          </div>
        </div>
        <div class="company">
          
        </div>
      </div>

    </div>
  </div>

  <div class="row data-row">
    <div class="col-12">
      <label>Position</label>
      <div class="value">
        {{getPositions()}}
      </div>
    </div>
  </div>
</div>
